import axios from "../../services/axios.config";
import VueJwtDecode from "vue-jwt-decode";
import {i18n} from "@/i18n/i18n";
import options from "../../../options";

const endpoints = {
  login: "auth/login/",
  refreshJWT: "auth/refresh_token/",
  verifyJWT: "auth/token_verify/",
  forgotPassword: "auth/password_reset/",
  resetPassword: "auth/password_reset/confirm/",
  register: "auth/register/",
};

const state = {
  authUserProfile: {},
  isAuthenticated: false,
  isAdmin: false,
  jwt: "",
  i18n: new i18n(options.lang),
};

const getters = {
  isAuthenticated: (state) => state.isAuthenticated,
  getToken: (state) => state.jwt,
  isAdminUser: (state) => state.isAdmin,
  userProfileData: (state) => state.authUserProfile,
  getEndpoints: () => endpoints,
  getLang: (state) => state.i18n,
};

const mutations = {
  AUTH_SUCCESS: (state, token) => {
    localStorage.setItem("token", token);
    state.jwt = token;
    state.isAuthenticated = true;
    state.authUserProfile = VueJwtDecode.decode(token);
  },
  AUTH_LOGOUT: (state) => {
    localStorage.removeItem("token");
    state.authUserProfile = {};
    state.jwt = "";
    state.isAuthenticated = false;
  },
  SET_LANG: (state, value) => {
    if (!value || value === "") value = "en";
    state.i18n = new i18n(value);
  },
};

const actions = {
  AUTH_REQUEST: async (context, user) => {
    let response = await axios.post(endpoints.login, user);
    if (response.status === 200) {
      let token = checkTokenResponse(response);
      if (token) {
        await actions.VERIFY_TOKEN(context, {token: token});
      }
    } else {
      throw Error(response.data);
    }
  },
  VERIFY_TOKEN: async (context, token) => {
    let response = await axios.post(endpoints.verifyJWT, token);
    if (response.status === 200) {
      let token = checkTokenResponse(response);
      if (token) {
        await actions.REFRESH_TOKEN(context, {token: token});
      }
    } else {
      throw Error(response.data);
    }
  },
  REFRESH_TOKEN: async (context, token) => {
    let response = await axios.post(endpoints.refreshJWT, token);
    if (response.status === 200) {
      let token = checkTokenResponse(response);
      if (token) {
        context.commit("AUTH_SUCCESS", token);
      }
    } else {
      throw Error(response.data);
    }
  },
  REGISTER_USER_REQUEST: async (context, user) => {
    let response = await axios.post(endpoints.register, user);
    if (response.status === 201) {
      context.commit("");
      return response.data;
    } else {
      throw Error(response.data);
    }
  },
  FORGOT_PASSWORD_REQUEST: async (context, email) => {
    let response = await axios.post(endpoints.forgotPassword, {email: email});
    if (response.status === 200) {
      context.commit("");
      return response.data;
    } else {
      throw Error(response.data);
    }
  },
  RESET_PASSWORD_REQUEST: async (context, user) => {
    let response = await axios.post(endpoints.resetPassword, {
      token: user.otp,
      password: user.password,
    });
    if (response.status === 200) {
      context.commit("");
      return response.data;
    } else {
      throw Error(response.data);
    }
  },
  AUTH_LOGOUT_REQUEST: (context) => {
    context.commit("AUTH_LOGOUT");
  },
  TOGGLE_LANGUAGE: (context, value) => {
    context.commit("SET_LANG", value);
  },
};

function checkTokenResponse(response) {
  const token = response.data?.token;
  if (token === null) {
    return null;
  }
  return token;
}

export default {
  state,
  getters,
  mutations,
  actions,
};
